<div class="w-full flex flex-col justify-center relative main-section" style="padding: 20px 0px 20px 0px" [ngClass]="{'is_loading': loading}">
  <!-- Sales list -->
  <div class="list">
    <div>
      <h3 class="list-title">Average Conversion Ratio by Sales Agent</h3>
    </div>
    @if (!loading) {
      <div class="top_users">
        @for (user of topUsers; track $index) {
          <div class="main-item-top">
            <div [ngClass]="{
              'top_index_zero': $index === 0,
              'top_index_one': $index === 1,
              'top_index_two': $index === 2
              }"  
              class="top_report_index"
            >
              <span>{{$index+1}}</span>
            </div>
            <p class="top_report_name">{{user?.name}}</p>
            <div class="top_report_data_items">
              <div class="top_report_leads">
                <p class="top_report_item_field">Leads<br>Count</p>
                <p class="top_report_item_value">{{user?.leads}}</p>
              </div>
              <div class="top_report_converted">
                <p class="top_report_item_field">Converted<br>Orders Count</p>
                <p class="top_report_item_value">{{user?.converted}}</p>
              </div>
              <div class="top_report_averageProfit">
                <p class="top_report_item_field">Average<br>Profit</p>
                <p class="top_report_item_value">${{$safeNavigationMigration(user?.averageProfit) | myCurrency}}</p>
              </div>
              <div class="top_report_totalProfit">
                <p class="top_report_item_field">Total<br>Profit</p>
                <p class="top_report_item_value">${{$safeNavigationMigration(user?.totalProfit) | myCurrency}}</p>
              </div>
              <div class="top_report_averageConv">
                <p class="top_report_item_field">Average<br>Conversion Ratio</p>
                <p class="top_report_item_value">{{user?.averageConv}}%</p>
              </div>
            </div>
          </div>
        }
      </div>
      <div class="header">
        <div class="header-title report-name">
          Name
          <button
            (click)="onSort('name', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'name',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'name'
              }"
            ></i>
          </button>
        </div>
        <div class="header-title report-leads text-center">
          Leads Count
          <button
            (click)="onSort('leads', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'leads',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'leads'
              }"
            ></i>
          </button>
        </div>
        <div class="header-title report-converted text-center">
          Converted  Orders Count
          <button
            (click)="onSort('converted', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'converted',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'converted'
              }"
            ></i>
          </button>
        </div>
        <div class="header-title report-averageProfit text-center">
          Average Profit
          <button
            (click)="onSort('averageProfit', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'averageProfit',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'averageProfit'
              }"
            ></i>
          </button>
        </div>
        <div class="header-title report-totalProfit text-center">
          Total Profit
          <button
            (click)="onSort('totalProfit', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'totalProfit',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'totalProfit'
              }"
            ></i>
          </button>
        </div>
        <div class="header-title report-averageConv text-center">
          Average Conversion Ratio
          <button
            (click)="onSort('averageConv', sortable.sort == 'incr' ? 'decr' : 'incr')"
            class="sort-button"
          >
            <i class="fa-solid text-gray-500"
              [ngClass]="{
                'fa-chevron-down': sortable.sort == 'incr' || sortable.field !== 'averageConv',
                'fa-chevron-up': sortable.sort == 'decr' && sortable.field == 'averageConv'
              }"
            ></i>
          </button>
        </div>
      </div>
      <div class="main">
        @for (user of otherUsers; track $index) {
          <div class="main-item flex items-baseline">
            <div class="report-name name-field-text">
              {{$index+1}}.&nbsp;{{user?.name}}
            </div>
            <div class="report-leads main-field text-center">
              <p class="centering-padding"><span [ngClass]="{'no_items': !user?.leads}">{{user?.leads}}</span></p>
            </div>
            <div class="report-converted main-field text-center">
              <p class="centering-padding"><span [ngClass]="{'no_items': !user?.converted}">{{user?.converted}}</span></p>
            </div>
            <div class="report-averageProfit main-field text-center">
              <p class="centering-padding"><span [ngClass]="{'no_items': !user?.averageProfit}">${{$safeNavigationMigration(user?.averageProfit) | myCurrency}}</span></p>
            </div>
            <div class="report-totalProfit main-field text-center">
              <p class="centering-padding"><span [ngClass]="{'no_items': !user?.totalProfit}">${{$safeNavigationMigration(user?.totalProfit) | myCurrency}}</span></p>
            </div>
            <div class="report-averageConv main-field text-center">
              <p class="centering-padding"><span [ngClass]="{'no_items': !user?.averageConv}">{{user?.averageConv}}%</span></p>
            </div>
          </div>
        }
      </div>
    }@else {
      <app-preloader [type]="'CONTENT_LIST'" [count]="15" [customHeight]="'80px'"></app-preloader>
    }
  </div>
  <div class="flex justify-between top_block">
    <div class="chart-box chart-box-summary w-1/2">
      <div class="flex justify-between items-center chart-header">
        <span class="large-black-text font-semibold leading-normal">Lead Summary</span>
      </div>
      <div class="info_stats">
        <div class="info_stats_orders">
          <div>
            @if (loading) {
              <div class="preloader_chart_total">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'50px'" [count]="1"></app-preloader>
              </div>
            } @else {
              <p class="stats_count_summary">{{_data?.totals?.orders}}</p>
            }
            <p class="stats_lable">Total Leads</p>
          </div>
        </div>
        <div class="info_stats_total">
          <div class="info_total_average">
            <div>
              @if (loading) {
                <div class="preloader_chart_total">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'50px'" [count]="1"></app-preloader>
                </div>
              } @else {
                <p class="stats_count_profit">~${{$safeNavigationMigration(_data?.totals?.profit?.average) | myCurrency}}</p>
              }
              <p class="stats_lable">Average Profit</p>
            </div>
          </div>
          <div class="stats_line"></div>
          <div class="info_total_profit">
            <div>
              @if (loading) {
                <div class="preloader_chart_total">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'50px'" [count]="1"></app-preloader>
                </div>
              } @else {
                <p class="stats_count_profit">${{$safeNavigationMigration(_data?.totals?.profit?.total) | myCurrency}}</p>
              }
              <p class="stats_lable">Profit Total</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="chart-box w-1/2">
      <div class="flex justify-between items-center chart-header chart-header-right">
        <div class="flex justify-between" style="flex: 1;">
            <span class="large-black-text font-semibold leading-normal">Average Company Conversion</span>
            <span class="updates_hourse">Data updates every 30 Minutes</span>
        </div>
      </div>
      @if(loading) {
        <div class="preloader_chart_ever_perc">
          <app-preloader [type]="'LARGE_LIST'" [customHeight]="'54px'" [count]="1"></app-preloader>
        </div>
      } @else {
        <p class="chart_aver_percentage stats_count_conversion">{{_data?.conversions?.totalPercent}}%</p>
      }
      <div class="chart-info-canvas canvas_info" [ngClass]="{'platform-chart-info': $safeNavigationMigration(_data?.totals)}">
        <canvas id="line" [ngStyle]="{'opacity': loading ? 0 : 1, 'position': loading ? 'absolute' : 'relative'}" chartLines></canvas>
        @if(loading){
          <div class="preloader_charts h-full">
            <div class="preloader_chart_prices">
              <div class="preloader_chart_price">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'10px'" [count]="1"></app-preloader>
              </div>
              <div class="preloader_chart_price">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'10px'" [count]="1"></app-preloader>
              </div>
              <div class="preloader_chart_price">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'10px'" [count]="1"></app-preloader>
              </div>
              <div class="preloader_chart_price">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'10px'" [count]="1"></app-preloader>
              </div>
              <div class="preloader_chart_price">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'10px'" [count]="1"></app-preloader>
              </div>
            </div>
            <div class="preloader_chart_img">
              <div class="w-full preloader_chart_img_bg">
                <app-preloader [type]="'LARGE_LIST'" [customHeight]="'100%'" [count]="1" [options]="{h_full: true}"></app-preloader>
              </div>
              <div class="preloader_chart_dates">
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
                <div class="preloader_chart_date">
                  <app-preloader [type]="'LARGE_LIST'" [customHeight]="'17px'" [count]="1"></app-preloader>
                </div>
              </div>
            </div>
          </div>
        }
          <!-- @if(!_data?.totals){
            <div class="empty-chart">
              <p class="empty-chart-info">On this chart, there is no information available for this period.</p>
            </div>
          } -->
      </div>
    </div>
  </div>
</div>
